import { PersonaAccessResponse } from '@frontend/epc';
export const SET_PERSONA_ACCESS_DATA = 'SET_PERSONA_ACCESS_DATA';


export const setPersonaAccessData = (payload: PersonaAccessResponse[]) => ({
  type: SET_PERSONA_ACCESS_DATA,
  payload,
});
